import api from "./axios";
import { DataFormat, ImportMode } from "@/constants";

export { DataFormat, ImportMode };

export const exportAll = (
  format: DataFormat = DataFormat.Json,
): Promise<Blob> =>
  api
    .get(`/export`, { params: { format }, responseType: "blob" })
    .then((r) => r.data);

export const importAll = (
  file: File,
  format: DataFormat = DataFormat.Json,
  mode: ImportMode = ImportMode.Merge,
): Promise<{ imported: Record<string, number> }> => {
  const formData = new FormData();
  formData.append("file", file);
  return api
    .post(`/import`, formData, {
      params: { format, mode },
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
